var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.55 34C16.95 33.9667 17.292 33.808 17.576 33.524C17.86 33.24 18.0013 32.8987 18 32.5C18 32.0333 17.85 31.6587 17.55 31.376C17.25 31.0933 16.8667 30.968 16.4 31C15.0333 31.1 13.5833 30.7253 12.05 29.876C10.5167 29.0267 9.55 27.4847 9.15 25.25C9.08333 24.8833 8.90867 24.5833 8.626 24.35C8.34333 24.1167 8.018 24 7.65 24C7.18333 24 6.8 24.1753 6.5 24.526C6.2 24.8767 6.1 25.2847 6.2 25.75C6.76667 28.7833 8.1 30.95 10.2 32.25C12.3 33.55 14.4167 34.1333 16.55 34ZM16 40C11.4333 40 7.62533 38.4333 4.576 35.3C1.52667 32.1667 0.00133333 28.2667 0 23.6C0 20.2667 1.32533 16.642 3.976 12.726C6.62667 8.81 10.6347 4.568 16 0C21.3667 4.56667 25.3753 8.80867 28.026 12.726C30.6767 16.6433 32.0013 20.268 32 23.6C32 28.2667 30.4753 32.1667 27.426 35.3C24.3767 38.4333 20.568 40 16 40Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/Water Drop.8d7b06bb6000a8aa5ce0879961b9821a.svg";
export { ForwardRef as ReactComponent };